document.addEventListener("DOMContentLoaded", function () {
  const faqSection = document.querySelector(".faq-section");
  if (!faqSection) return;

  const faqItems = faqSection.querySelectorAll(".faq-item");
  if (!faqItems.length) return;

  // 🔹 Open first FAQ by default
  const firstItem = faqItems[0];
  const firstQ = firstItem.querySelector(".faq-question");
  const firstA = firstItem.querySelector(".faq-answer");

  firstItem.classList.add("open");
  firstQ.classList.add("active");
  firstA.style.height = firstA.scrollHeight + "px";

  faqItems.forEach((item) => {
    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");

    if (!question || !answer) return;

    question.addEventListener("click", () => {
      const isOpen = item.classList.contains("open");

      // 🔹 Close all
      faqItems.forEach((i) => {
        i.classList.remove("open");
        const q = i.querySelector(".faq-question");
        const a = i.querySelector(".faq-answer");
        if (q) q.classList.remove("active");
        if (a) a.style.height = 0;
      });

      // 🔹 Open current
      if (!isOpen) {
        item.classList.add("open");
        question.classList.add("active");
        answer.style.height = answer.scrollHeight + "px";
      }
    });
  });
});
